/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "GMacchia",
  title: "Hi there, I'm Giuseppe",
  subTitle: emoji(
    "An enthusiastic Full Stack Software Developer 🚀 with expertise in crafting both Web and Mobile applications using technologies such as Angular / Ionic / Capacitor / Node.js / ParseServer / Spring Boot and various other cutting-edge libraries and frameworks."
  ),
  resumeLink: "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/beppemacchia",
  linkedin: "https://www.linkedin.com/in/giuseppe-macchia/",
  gmail: "hello@giuseppemacchia.it",
  facebook: "https://www.facebook.com/beppe.macchia",
  instagram: "https://www.instagram.com/beppemacchia88",
  twitter: "https://x.com/BeppeMacchia",
  // medium: "https://medium.com/",
  // stackoverflow: "https://stackoverflow.com/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "ECCENTRIC FULL STACK DEVELOPER EAGER TO EMBRACE DIVERSE TECH STACKS",
  skills: [
    emoji(
      "⚡ Craft engaging front-end and user interfaces for your web and mobile applications"
    ),
    emoji(
      "✨ Create Progressive Web Applications (PWAs) and Hybrid Mobile Application"
    ),
    emoji("💫 Backend powered by Node.js / SpringBoot / PHP")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "parse",
      skillImage: require("./assets/images/parse.png"),
      skillAlt: "Parse Platform"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    /* {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }*/
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer",
      company: "Corvallis S.R.L.",
      companylogo: require("./assets/images/corvallisLogo.png"),
      date: "Opt 2021 - Present",
      desc: "Design and development of Web & Mobile Apps for independent innovative platforms, using the SCRUM methodology and employing Java, Javascript, Angular, Ionic, and Capacitor."
    },
    {
      role: "Full Stack Developer",
      company: "ZeroDD - Soluzioni Informatiche",
      companylogo: require("./assets/images/ZeroDD.png"),
      date: "Dec 2015 – Opt 2021",
      desc: "I have been working externally as a consultant at:",
      descBullets: [
        "Consorzio Gruppo Monte dei Paschi di Siena, developing Web & Mobile App components for Banca Monte dei Paschi di Siena using the SCRUM methodology. I use Java, Javascript, Angular, Cordova, Ionic, and NativeScript.",
        "Previously, I held similar roles at Links Management and Technologies, contributing to the development of components for IWBank.",
        "I have experience in developing Web & Mobile App components for various independent platforms, using technologies such as PHP, Java, Swift, Objective-C, Android, Cordova, Ionic, Angular, and Javascript."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Startups",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/cuvifyLogo.png"),
      projectName: "Co-Founder",
      projectDesc:
        "Web platform and App for emerging writers and freemium readers",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://cuvify.it/"
        }
      ]
    },
    {
      image: require("./assets/images/easygustoLogo.png"),
      projectName: "Co-Founder",
      projectDesc:
        "Quick and easy app to order lots of tasty dishes to be delivered wherever you want.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://easygusto.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Winner PIN Giovani",
      subtitle:
        "PIN is an initiative of the Youth Policies of the Puglia Region aimed at young men and women who intend to carry out innovative entrepreneurial projects with high local development potential and with good prospects for consolidation, strengthening their skills.",
      image: require("./assets/images/pinWinner.png"),
      imageAlt: "PIN Giovani Puglia - Vincitore",
      footerLink: [
        {
          name: "Project",
          url: "https://pingiovani.regione.puglia.it/vincitori/cuvify"
        },
        {
          name: "Final Project",
          url: "https://open.cuvify.it/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    /*  {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }*/
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    /* {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }*/
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    // "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+92-0000000000",
  email_address: "hello@giuseppemacchia.it"
};

// Twitter Section

const twitterDetails = {
  userName: "BeppeMacchia", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
